/* eslint-disable react-hooks/exhaustive-deps */
import React, { } from 'react';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { DataGrid } from '@mui/x-data-grid';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import UpdateGuestMovement from './UpdateGuestMovements';
import ViewGuestsMovementsDetails from './ViewGuestsMovementsDetails';
import DeleteGuestMovements from './DeleteGuestMovements';
// import ColoredSquare from '../ColoredSquare/ColoredSquare';

const GuestsMovemetsTable = ({ fromHome, kioskMode }) => {
  const { convertUtcToLocal, formatDateTimeToItalian, guestsMovements } = useStateContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // screens smaller than 960px
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm')); // screens smaller than 600px
  
  const getRowBackgroundColorClassName = (params) => {
    // if movement is 'entrata' then set the class name to 'entrata'
    return `${params.row.movement_type}`;
  };

  // Base columns that are always visible
  const baseColumns = [
    {
      field: 'surname',
      headerName: 'Cognome',
      headerClassName: 'datagrid-table-custom-headers',
      headerAlign: 'center',
      align: 'center',
      flex: isMobile ? 1 : 1,
      minWidth: isMobile ? 100 : 110,
      maxWidth: isMobile ? 140 : undefined,
      renderCell: (params) => (
        <div style={{ 
          whiteSpace: 'normal', 
          lineHeight: 'normal', 
          textAlign: 'center',
          fontSize: isMobile ? '0.8rem' : '1rem',
          wordBreak: 'break-word'
        }}>
          {params.value}
        </div>
      ),
    },
    {
      field: 'name',
      headerName: 'Nome',
      headerClassName: 'datagrid-table-custom-headers',
      headerAlign: 'center',
      align: 'center',
      flex: isMobile ? 1 : 1,
      minWidth: isMobile ? 100 : 110,
      maxWidth: isMobile ? 140 : undefined,
      renderCell: (params) => (
        <div style={{ 
          whiteSpace: 'normal', 
          lineHeight: 'normal', 
          textAlign: 'center',
          fontSize: isMobile ? '0.8rem' : '1rem',
          wordBreak: 'break-word'
        }}>
          {params.value}
        </div>
      ),
    },
    {
      field: 'movement_type',
      headerName: isMobile ? 'Tipo' : 'Tipo',
      headerClassName: 'datagrid-table-custom-headers',
      headerAlign: 'center',
      align: 'center',
      flex: isMobile ? 0.9 : 1,
      minWidth: isMobile ? 90 : 110,
      maxWidth: isMobile ? 120 : undefined,
      renderCell: (params) => (
        <div style={{ 
          whiteSpace: 'normal', 
          lineHeight: 'normal', 
          textAlign: 'center',
          fontSize: isMobile ? '0.8rem' : '1rem',
          wordBreak: 'break-word'
        }}> 
          {params.value}
        </div>
      ),
    },
  ];

  // Desktop-only columns
  const desktopColumns = [
    {
      field: 'expected_date',
      headerName: 'Data prevista',
      headerClassName: 'datagrid-table-custom-headers',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 110,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
          {params.value && formatDateTimeToItalian(convertUtcToLocal(params.value))}
        </div>
      ),
    },
    {
      field: 'from_room',
      headerName: 'Stanza di provenienza',
      headerClassName: 'datagrid-table-custom-headers',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 110,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: 'to_room',
      headerName: 'Stanza di destinazione',
      headerClassName: 'datagrid-table-custom-headers',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 110,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
          {params.value}
        </div>
      ),
    },
    // {
    //   field: 'gender',
    //   headerName: 'Genere',
    //   headerClassName: 'datagrid-table-custom-headers',
    //   headerAlign: 'center',
    //   align: 'center',
    //   flex: 1,
    //   minWidth: 110,
    //   renderCell: (params) => (
    //     <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
    //       {params.value}
    //     </div>
    //   ),
    // },
    // {
    //   field: 'colour',
    //   headerName: 'Colore',
    //   headerClassName: 'datagrid-table-custom-headers',
    //   headerAlign: 'center',
    //   align: 'center',
    //   flex: 1,
    //   minWidth: 110,
    //   renderCell: (params) => (
    //     <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
    //       <ColoredSquare bgColor={params.value} dimension='30px' />
    //     </div>
    //   ),
    // },
    // {
    //   field: 'physician',
    //   headerName: 'Medico',
    //   headerClassName: 'datagrid-table-custom-headers',
    //   headerAlign: 'center',
    //   align: 'center',
    //   flex: 1,
    //   minWidth: 110,
    //   renderCell: (params) => (
    //     <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
    //       {params.value}
    //     </div>
    //   ),
    // },
    // {
    //   field: 'notes',
    //   headerName: 'Note',
    //   headerClassName: 'datagrid-table-custom-headers',
    //   headerAlign: 'center',
    //   align: 'center',
    //   flex: 1,
    //   minWidth: 110,
    //   renderCell: (params) => (
    //     <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
    //       {params.value}
    //     </div>
    //   ),
    // },
  ];

  // Mobile-only compact column that combines room info
  const mobileRoomColumn = {
    field: 'rooms_info',
    headerName: 'Stanze e Data',
    headerClassName: 'datagrid-table-custom-headers',
    headerAlign: 'center',
    align: 'center',
    flex: 1.2,
    minWidth: 120,
    maxWidth: 160,
    renderCell: (params) => (
      <div style={{ 
        whiteSpace: 'normal', 
        lineHeight: '1.2', 
        textAlign: 'center',
        fontSize: '0.75rem',
        wordBreak: 'break-word'
      }}>
        <div><strong>Da:</strong> {params.row.from_room || 'N/A'}</div>
        <div><strong>A:</strong> {params.row.to_room || 'N/A'}</div>
        <div style={{ fontSize: '0.7rem', color: '#666', marginTop: '2px' }}>
          {params.row.expected_date && formatDateTimeToItalian(convertUtcToLocal(params.row.expected_date))}
        </div>
      </div>
    ),
  };

  // Build columns array based on screen size
  const columns = [...baseColumns];
  
  if (isMobile) {
    columns.push(mobileRoomColumn);
  } else {
    columns.push(...desktopColumns);
  }

  // if is not from kiosk add also the view details button
  if (!kioskMode) {
    columns.push(
      {
        field: 'details',
        headerName: '',
        headerClassName: 'datagrid-table-custom-headers',
        headerAlign: 'center',
        align: 'center',
        width: isMobile ? 50 : 100,
        renderCell: (params) => (
          <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
            <ViewGuestsMovementsDetails guestMovement={params.row} />
          </div>
        ),
      },
    )
  }

  // if is not from home add also the update button column (hide on small mobile to save space)
  if (!fromHome && !isSmallMobile) {
    columns.push(
      {
        field: 'update',
        headerName: '',
        headerClassName: 'datagrid-table-custom-headers',
        headerAlign: 'center',
        align: 'center',
        width: isMobile ? 50 : 100,
        renderCell: (params) => (
          <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
            {params.row.executed ? <p>Movimento già eseguito</p> : <UpdateGuestMovement oldGuestMovement={params.row} />} 
          </div>
        ),
      },
    )
  }

  // after inserting the optional fields push the delete field if not from home and not from kiosk (hide on small mobile)
  if (!fromHome && !kioskMode && !isSmallMobile) {
    columns.push(
      {
        field: 'id',
        headerName: '',
        headerClassName: 'datagrid-table-custom-headers',
        headerAlign: 'center',
        align: 'center',
        width: isMobile ? 50 : 100,
        renderCell: (params) => (
          <div style={{ whiteSpace: 'normal', lineHeight: 'normal', textAlign: 'center' }}>
            <DeleteGuestMovements movId={params.value} />
          </div>
        ),
      },
    )
  }

  // Responsive row height
  const getRowHeight = () => {
    if (isSmallMobile) return 90; // Slightly taller for small screens due to compact layout
    if (isMobile) return 85;
    return 80;
  };

  // Responsive page size
  const getDefaultPageSize = () => {
    if (fromHome) {
      return isSmallMobile ? 3 : 5; // Fewer items on small mobile screens
    }
    return isMobile ? 8 : 10;
  };

  return (
    <>
      {fromHome && <h4>Movimento ospiti:</h4>}
      {isSmallMobile && !fromHome && !kioskMode && (
        <p style={{ fontSize: '0.8rem', color: '#666', marginBottom: '10px' }}>
          Tocca "Dettagli" per vedere tutte le informazioni e le azioni disponibili.
        </p>
      )}
      {guestsMovements.length > 0 ? (
        <div style={{ 
          overflow: 'auto', 
          width: '100%',
          maxWidth: '100vw', // Prevent horizontal overflow on mobile
        }} className='shadowClass'>
          <div style={{ 
            width: '100%',
            minWidth: isMobile ? '500px' : 'auto', // Increased minimum width for mobile to accommodate headers
          }} className='scrollbar-data-grid'>
            <DataGrid
              rows={guestsMovements}
              columns={columns}
              getRowId={(row) => row.id}
              getRowClassName={getRowBackgroundColorClassName}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: getDefaultPageSize() },
                },
              }}
              pageSizeOptions={isMobile ? [3, 5, 8] : [5, 10, 15]}
              rowHeight={getRowHeight()}
              rowSelection={false}
              sx={{
                // Custom styles for mobile
                '& .MuiDataGrid-cell': {
                  padding: isMobile ? '4px' : '8px',
                  fontSize: isMobile ? '0.8rem' : '1rem',
                },
                '& .MuiDataGrid-columnHeader': {
                  padding: isMobile ? '4px' : '8px',
                  fontSize: isMobile ? '0.8rem' : '1rem',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 'bold',
                  fontSize: isMobile ? '0.75rem' : '0.9rem',
                },
                // Better mobile scrolling
                '& .MuiDataGrid-virtualScroller': {
                  overflowX: 'auto',
                },
                // Responsive pagination
                '& .MuiTablePagination-toolbar': {
                  flexWrap: isMobile ? 'wrap' : 'nowrap',
                },
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                },
              }}
            />
          </div>
        </div>
      ) : (
        <p>Nessun movimento ospiti trovato {fromHome && 'per oggi '}...</p>
      )}
    </>
  );
};

export default GuestsMovemetsTable;